import { Card, Grid, Skeleton } from "@mui/material";

const NewsCardSkeleton = () => <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
    <Card sx={{
        height: 515,
        p: 1.5,
        width: "100%",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    }}>

        <Skeleton
            sx={{ alignSelf: "center" }}
            variant="rounded"
            width="100%"
            height="30px"
        />

        <Skeleton
            sx={{ alignSelf: "center" }}
            variant="rounded"
            height="250px"
            width="100%"
        />

        <Skeleton
            sx={{ alignSelf: "center" }}
            variant="rounded"
            height="72px"
            width="100%"
        />

        <Skeleton
            sx={{ alignSelf: "center" }}
            variant="rounded"
            height="56px"
            width="121px"
        />

    </Card>
</Grid>

export default NewsCardSkeleton;